import { Link } from "wouter";
import { Helmet } from "react-helmet-async";
import { Home, Phone } from "lucide-react";
import notFoundHero from "@/assets/photos/roof-replacement-aerial.webp";

export default function NotFound() {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      <Helmet>
        <title>Page Not Found | Graystone Roofing & Siding</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <section className="relative bg-secondary overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src={notFoundHero} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-secondary/85 mix-blend-multiply" />
          <div className="absolute inset-0 bg-gradient-to-t from-secondary via-secondary/80 to-transparent" />
        </div>
        <div className="container mx-auto px-4 relative z-10 py-24 md:py-32 text-center">
          <p className="text-primary-foreground/80 font-bold text-sm uppercase tracking-wide mb-3">Error 404</p>
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4">
            This Page Could Not Be Found
          </h1>
          <p className="text-lg text-secondary-foreground/90 mb-8 max-w-2xl mx-auto">
            The page you are looking for may have moved or no longer exists. Let's get you back on solid footing.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link
              href="/"
              className="bg-primary text-primary-foreground px-6 py-3 rounded font-bold hover:bg-primary/90 transition-colors shadow-sm inline-flex items-center gap-2"
            >
              <Home className="h-4 w-4" aria-hidden="true" /> Back to Home
            </Link>
            <a
              href="tel:+17177257170"
              className="bg-white/10 text-white border border-white/20 px-6 py-3 rounded font-bold hover:bg-white/20 transition-colors backdrop-blur-sm inline-flex items-center gap-2"
            >
              <Phone className="h-4 w-4" aria-hidden="true" /> Call 717-725-7170
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
